export { MaterialTabs } from './MaterialTabs';
